import { render, staticRenderFns } from "./report-video.vue?vue&type=template&id=2245c8d2&scoped=true&"
import script from "./report-video.vue?vue&type=script&lang=js&"
export * from "./report-video.vue?vue&type=script&lang=js&"
import style0 from "./report-video.vue?vue&type=style&index=0&id=2245c8d2&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2245c8d2",
  null
  
)

export default component.exports